import { NetworkActionPrefix, ActionType, PersistentSearchResultsFromBingKey } from '../utils/constants';
import defaults from '../api/defaults';
import {
    combineReducers, pipeReducers, networkObjectLoadReducer, networkEntityEditReducer, synchronizableEnumReducer, networkEntityAddAllReducer,
    networkEntityDeleteAllReducer, networkEntityAddReducer, networkEntityDeleteReducer, networkActionReducer 
} from '../utils/reducerFactory';
import { deepAssign } from '../utils';
import { LOCATION_CHANGE } from 'react-router-redux';
import { queryToEntity } from '../api/utils';
import { NewsEntryFilter } from 'for-straction-service-api';

function index(state, id) {
    return id !== undefined ? (id = state.getIndexByID(id)) !== -1 ? id : state.length : undefined;
}

const searchResultsFromBing = pipeReducers(
    networkObjectLoadReducer(NetworkActionPrefix.GET_SEARCH_RESULTS_FROM_BING_PREFIX, defaults.NetworkObjectOf(defaults.BingCognitiveData)),
    (state, action) => action.type === ActionType.DROP_SEARCH_RESULTS_FROM_BING ?
        Object.values(PersistentSearchResultsFromBingKey).includes(action.searchKey) ?
            DEFAULT_SEARCH_RESULTS :
            null :
        state
);

const keyVariables = {
    marketFeedBingCognitiveIndex: (state, action) => index(state, action.marketFeedBingCognitiveID)
}

const DEFAULT_SEARCH_RESULTS = searchResultsFromBing(undefined, { type: '@@redux/INIT' });

const searchResultsDictionary = combineReducers({
    "@searchKey": searchResultsFromBing
}, { searchKey: (state, action) => action.searchKey });

const bingSearch = pipeReducers(
    combineReducers({
        marketFeedBingCognitives: pipeReducers(
            networkObjectLoadReducer(NetworkActionPrefix.LOAD_ALL_MARKET_FEED_BING_COGNITIVES_PREFIX, defaults.NetworkArray),
            networkActionReducer(NetworkActionPrefix.ADD_ALL_MARKET_FEED_BING_COGNITIVES_PREFIX, null, (state, action) => action.marketFeedBingCognitives),
            networkActionReducer(NetworkActionPrefix.EDIT_ALL_MARKET_FEED_BING_COGNITIVES_PREFIX, null, (state, action) => action.marketFeedBingCognitives),
            networkActionReducer(NetworkActionPrefix.DELETE_ALL_MARKET_FEED_BING_COGNITIVES_PREFIX, null, (state, action) => action.marketFeedBingCognitiveIDs),
            combineReducers({
                Data: combineReducers({
                    "@marketFeedBingCognitiveIndex": pipeReducers(
                        networkEntityAddReducer(NetworkActionPrefix.ADD_MARKET_FEED_BING_COGNITIVE_PREFIX, null, (state, action) => action.marketFeedBingCognitive),
                        networkEntityEditReducer(NetworkActionPrefix.EDIT_MARKET_FEED_BING_COGNITIVE_PREFIX, defaults.MarketFeedBingCognitive, (state, action) => action.marketFeedBingCognitive),
                        networkEntityDeleteReducer(NetworkActionPrefix.DELETE_MARKET_FEED_BING_COGNITIVE_PREFIX)
                    )
                }, keyVariables)
            }),
            (state, action) => {
                switch (action.type) {
                    case ActionType.ADD_ALL_MARKET_FEED_BING_COGNITIVES_SUCCESS:
                        return deepAssign(state, {
                            Data: [...state.Data, ...action.marketFeedBingCognitives.map((source, index) => ({ ...source, ID: action.response[index] }))]
                        });

                    case ActionType.EDIT_ALL_MARKET_FEED_BING_COGNITIVES_SUCCESS:
                        return deepAssign(state, {
                            Data: state.Data.map(watch => action.marketFeedBingCognitives.getByID(watch.ID) || watch)
                        });

                    case ActionType.DELETE_ALL_MARKET_FEED_BING_COGNITIVES_SUCCESS:
                        return deepAssign(state, {
                            Data: state.Data.filter(watch => !action.marketFeedBingCognitiveIDs.includes(watch.ID))
                        });

                    case ActionType.DELETE_TREND_TOPIC_SUCCESS:
                        return deepAssign(state, {
                            Data: state.Data.map(watch => ({
                                ...watch,
                                TrendTopicID: action.trendTopicID === watch.TrendTopicID ? defaults.MarketFeedBingCognitive.TrendTopicID : watch.TrendTopicID
                            }))
                        });

                    default:
                        return state;
                }
            }
        ),
        searchResultsFromBing: (state, action) => searchResultsDictionary(state || Object.values(PersistentSearchResultsFromBingKey).reduce((r, k) => (r[k] = DEFAULT_SEARCH_RESULTS, r), {}), action),
        sourcesFilter: (state, action) =>
            action.type === LOCATION_CHANGE && action.payload.pathname === '/market_radar/sources/bing' ?
                deepAssign(state, queryToEntity(action.payload.query, NewsEntryFilter)) :
                state || defaults.NewsEntryFilter
    }),
    function (state, action) {
        switch (action.type) {
            case ActionType.DELETE_SWOT_SESSION_SUCCESS:
            case ActionType.DELETE_SWOT_TOPIC_SUCCESS:
            case ActionType.DELETE_STAKEHOLDER_SUCCESS:
            case ActionType.DELETE_TREND_TOPIC_SUCCESS:
                // TODO make it more targeted, not all parts require update
                return bingSearch(undefined, { type: '@@redux/INIT' });
            default:
                return state;
        }
    }
);

export default bingSearch;